"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineIcon = void 0;
var react_1 = __importDefault(require("react"));
var InlineIcon = function (props) { return (react_1.default.createElement(react_1.default.Fragment, null, props.name && (react_1.default.createElement("span", { className: "".concat(props.className, " p-1 text-sm icon-").concat(props.name, " ") })))); };
exports.InlineIcon = InlineIcon;
